import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import FileUpload from "./pages/FileUpload/FileUpload";
import Login from "./pages/Login/Login";
import PrivateRoutes from "./utils/PrivateRoutes";

const App = () => {

  return (
    <div>
        <BrowserRouter>
          <Routes>
            <Route element={<PrivateRoutes />}>
              <Route path="/" element={<FileUpload />} />
            </Route>
            <Route path="/login" element={<Login />} />
          </Routes>
        </BrowserRouter>
    </div>
  );
};

export default App;
